import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import {
    FTPAutoComplete,
    FTPFormButton,
    FTPInput,
    FTPRadioGroup,
} from "../../components-new";

import { useStore } from "../../helpers";
import { safe_get } from "../../report-visuals";
import {
    defaultvoterinfovalues,
    voterEligibilitySchema,
} from "./voterinfo-schema";
import { yupResolver } from "@hookform/resolvers/yup";
import { useParams } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { VortexSpinner } from "../digital-repository";

export const VoterEligibilityCheck = observer((props: any) => {
    const rootStore = useStore();
    const { voterListStore, projectStore } = rootStore;
    const projectProperties = projectStore.getProjectProperty(
        "project_state",
        {}
    );
    const { aiGentoolStore } = useStore();
    const { activeVoter } = voterListStore;
    const age = safe_get(activeVoter, "profile.age", null);
    const gender = safe_get(activeVoter, "profile.gender", null);
    const beneficiaryState = safe_get(
        projectProperties,
        "beneficiaryState",
        null
    );
    const voterid = safe_get(activeVoter, "profile.voterid", null);
    const { projectid } = useParams();
    const queryClient = useQueryClient();
    const { activeEligibiltyDetails } = aiGentoolStore;
    console.log(activeVoter, "activeVoter");

    const methods = useForm<any>({
        defaultValues: {
            ...defaultvoterinfovalues,
        },
        resolver: yupResolver(voterEligibilitySchema),
    });

    const CasteInfo = [
        "Other Backward Class (OBC)",
        "Particularly Vulnerable Tribal Group (OBC)",
        "Scheduled Caste (SC)",
        "Scheduled Tribe (ST)",
    ];
    const Qualification = [
        "Below Metric",
        "Metric",
        "Post Metric",
        "Under Graduate",
        "Post Graduate",
        "Other",
    ];
    const Disability = ["Yes", "No"];
    const DisabilityPercentage = ["<40%", "40%-60%", "60%-80%", ">80%"];
    const Student = ["Yes", "No"];
    const AffectedBy = [
        "COVID-19",
        "Disasters / Natural Calamity",
        "Cancer",
        "Serious Disease",
        "Pregnancy",
        "Miscarriage",
        "Death in Family",
        "Accident",
        "Animal Death (Calves / Sheep / Goats)",
        "Extreme Poverty",
        "Child Labour",
        "Homelessness",
        "None",
    ];

    const Marital = ["Single", "Married", "Widowed"];
    const Residence_Types = ["Urban", "Rural"];
    const Employment = ["Employed", "Unemployed", "Self-Employed"];
    const Occupation = [
        "Construction Worker",
        "Farmer",
        "Fisherman",
        "Dairy Farmer",
        "Coir Worker",
        "Artist",
        "Doctor",
        "Engineer",
        "Teacher",
        "Author",
        "Journalist",
        "Sports Person",
        "Driver (Autorickshaw / Taxi)",
        "Street Vendor",
        "Health Worker",
        "Safai Karmachari",
        "Ex-Serviceman",
        "Unorganised Worker",
        "Organised Worker",
    ];

    const { watch, setValue } = methods;
    const disability = watch("disability");
    const isStudent = watch("isStudent");
    const employment = watch("employement");
    const governmentEmployee = watch("governmentEmployee");
    const bpl = watch("bpl");

    useEffect(() => {
        if (disability === "No") setValue("disabilityPercentage", "");
    }, [disability, setValue]);

    useEffect(() => {
        if (isStudent === "No") setValue("parentIncome", "");
    }, [isStudent, setValue]);

    useEffect(() => {
        if (employment !== "Self-Employed") setValue("occupation", "");
    }, [employment, setValue]);

    useEffect(() => {
        if (governmentEmployee === "Yes") setValue("occupation", "");
    }, [governmentEmployee, setValue]);

    useEffect(() => {
        if (bpl === "Yes") setValue("familyIncome", "");
    }, [bpl, setValue]);

    useEffect(() => {
        if (activeEligibiltyDetails) {
            methods.reset({
                ...defaultvoterinfovalues,
                ...activeEligibiltyDetails,
            });
        }
    }, [activeEligibiltyDetails, methods]);
    console.log(activeEligibiltyDetails, "activeEligibilityDetails");

    useEffect(() => {
        const shouldShowOccupation =
            isStudent !== "Yes" &&
            (employment === "Self-Employed" || governmentEmployee === "No");

        if (!shouldShowOccupation) {
            setValue("occupation", "");
        } else {
            setValue("occupation", activeEligibiltyDetails?.occupation);
        }
    }, [
        activeEligibiltyDetails,
        isStudent,
        employment,
        governmentEmployee,
        setValue,
    ]);

    const { mutate, isLoading } = useMutation({
        mutationFn: async (data: any) => {
            return aiGentoolStore.check_voter_scheme_eligibility(data);
        },
        onSuccess: async (data) => {
            toast.success("Eligibility Check Successfully!");
            voterListStore.update_info_scheme(false);

            await queryClient.invalidateQueries([
                "voter-eligible-schemes",
                projectid,
                voterid,
            ]);
            setTimeout(() => {
                voterListStore.update_voter_eligible_scheme_list(
                    data?.data || []
                );
                voterListStore.update_voter_scheme_profile(
                    data?.data?.scheme_profile || {}
                );
                voterListStore.update_voter_eligible_schemes(true);
            }, 1000);
        },

        onError: () => {
            toast.error("Eligibility Check Error!");
        },
    });

    if (isLoading) {
        return <VortexSpinner visible={true} />;
    }

    const onSubmit = (data: any) => {
        const payload = {
            profile: {
                age: age,
                gender: gender?.toLowerCase(),
                beneficiaryState: beneficiaryState,
                ...data,
            },
            voterid: voterid,
            projectid: parseInt(projectid),
        };

        mutate(payload);
    };

    const close_modal = () => {
        aiGentoolStore.setActiveEligibiltyDetails(null);
        voterListStore.update_info_scheme(false);
        // voterListStore.update_voter_eligible_schemes(true);
    };

    return (
        <div>
            <FormProvider {...methods}>
                <form
                    className="flex flex-col gap-y-4 rounded-xl bg-common-white p-4"
                    onSubmit={methods.handleSubmit(onSubmit)}
                >
                    <FTPRadioGroup
                        name="residence"
                        label="Residence"
                        options={Residence_Types}
                    />

                    {gender === "Female" && age > 18 && (
                        <FTPAutoComplete
                            name="marital"
                            label="Marital Status"
                            data={Marital}
                            placeholder="Enter Marital Status"
                        />
                    )}

                    <div className="flex gap-x-2">
                        <FTPAutoComplete
                            name="caste"
                            label="Caste"
                            data={CasteInfo}
                            placeholder="Enter Caste"
                        />
                        <FTPAutoComplete
                            name="qualification"
                            label="Qualification"
                            data={Qualification}
                            placeholder="Enter Qualification"
                        />
                    </div>

                    <div className="flex gap-x-2">
                        <FTPAutoComplete
                            name="disability"
                            label="Disability"
                            data={Disability}
                            placeholder="Enter Details"
                        />
                        {disability === "Yes" && (
                            <FTPAutoComplete
                                name="disabilityPercentage"
                                label="Disability Percentage"
                                data={DisabilityPercentage}
                                placeholder="Select Percentage"
                            />
                        )}
                    </div>

                    <FTPAutoComplete
                        name="minority"
                        label="Minority"
                        data={Disability}
                        placeholder="Enter Details"
                    />

                    <div className="flex gap-x-2">
                        <FTPAutoComplete
                            name="isStudent"
                            label="Student"
                            data={Student}
                            placeholder="Enter Details"
                        />
                        {isStudent === "No" && (
                            <FTPAutoComplete
                                name="employement"
                                label="Current Employment"
                                data={Employment}
                                placeholder="Enter Details"
                            />
                        )}
                    </div>

                    {isStudent === "Yes" && (
                        <FTPInput
                            label="Parent / Guardian's annual Income"
                            name="parentIncome"
                        />
                    )}

                    {employment === "Employed" && (
                        <FTPAutoComplete
                            name="governmentEmployee"
                            label="Current Government Employee"
                            data={Student}
                            placeholder="Enter Details"
                        />
                    )}

                    {/*{(employment === "Self-Employed" || governmentEmployee === "No") && (*/}
                    {/*  <FTPAutoComplete*/}
                    {/*    name="occupation"*/}
                    {/*    label="Occupation"*/}
                    {/*    data={Occupation}*/}
                    {/*    placeholder="Enter Details"*/}
                    {/*  />*/}
                    {/*)}*/}
                    {isStudent !== "Yes" &&
                        (employment === "Self-Employed" ||
                            governmentEmployee === "No") && (
                            <FTPAutoComplete
                                name="occupation"
                                label="Occupation"
                                data={Occupation}
                                placeholder="Enter Details"
                            />
                        )}

                    <FTPAutoComplete
                        name="bpl"
                        label="BPL Category"
                        data={Student}
                        placeholder="Enter Details"
                    />

                    {bpl === "No" && (
                        <FTPInput
                            label="Family annual income"
                            name="familyIncome"
                        />
                    )}

                    <FTPAutoComplete
                        name="affected"
                        label="Affected By"
                        data={AffectedBy}
                        placeholder="Enter Details"
                    />

                    <div className="mt-4 flex justify-end gap-x-2">
                        <FTPFormButton
                            actionType="Cancel"
                            handleButtonClick={close_modal}
                        />
                        <FTPFormButton
                            actionType="Save"
                            handleButtonClick={methods.handleSubmit(onSubmit)}
                        />
                    </div>
                </form>
            </FormProvider>
        </div>
    );
});
